import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgClockCounterClockwiseDuotone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M23.625 14a9.625 9.625 0 1 1-19.251 0 9.625 9.625 0 0 1 19.251 0Z"
      opacity={0.2}
    />
    <path d="M14.875 8.75v4.755l3.95 2.37a.875.875 0 1 1-.9 1.5l-4.376-2.625a.874.874 0 0 1-.424-.75V8.75a.875.875 0 0 1 1.75 0ZM14 3.5a10.439 10.439 0 0 0-7.429 3.079 45.144 45.144 0 0 0-2.196 2.39V7a.875.875 0 0 0-1.75 0v4.375a.875.875 0 0 0 .875.875h4.375a.875.875 0 0 0 0-1.75H5.359a47.304 47.304 0 0 1 2.45-2.687 8.75 8.75 0 1 1 .18 12.55.876.876 0 0 0-1.202 1.274A10.5 10.5 0 1 0 14 3.5Z" />
  </svg>
);
export default SvgClockCounterClockwiseDuotone;
